<div style="text-align: -webkit-center; margin-top: 3rem;">
    <div class="card">
        <!--SURVEY HEADER-->
        <div *ngIf="isDisplayed" id="surveyTitle">{{surveyTitle}}</div>
        <div *ngIf="isDisplayed" id="surveySubTitle">{{surveySubTitle}} </div>
        <!--SPINNER WHILE FETCHING DATA-->
        <div *ngIf="loading" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
            <mat-spinner diameter="30"></mat-spinner>
        </div>
        <div>
            <!--FINISHED SURVEY MESSAGE-->
            <div *ngIf="!isDisplayed" style="text-align: -webkit-center;text-align: -moz-center; padding: 2rem 0px">
                <p style="font-size: 1.5em; font-family: akzidenz-grotesk-light;">{{'SUCCESS_SURVEY' | translate}}</p>
            </div>
            <!--DISPLAYED QUESTION-->
            <div *ngIf="isDisplayed">
                <div *ngIf="!loading ">
                    <!--SINGLE SELECT-->
                    <div class="question"
                        *ngIf="displayedQuestion.type == 'single-select' || displayedQuestion.type == 'single-select-special'">
                        <h2>{{index}}. <span [innerHTML]="displayedQuestion.text"></span></h2>
                        <div class="row text-left options">
                            <mat-radio-group name="singleAnswers">
                                <div class="" *ngFor="let option of displayedQuestion.availableOptions">
                                    <div class="option">
                                        <mat-radio-button *ngIf="displayedQuestion.type == 'single-select'"
                                            [value]="{id: option.num, text:option.text }" [checked]="isChecked(option)"
                                            (change)="onSingleSelect(option)">
                                            <span style="white-space: normal;">{{option.text}}</span>
                                        </mat-radio-button>
                                        <mat-radio-button *ngIf="displayedQuestion.type == 'single-select-special'"
                                            [value]="{id: option.num, text:option.text }" [checked]="isChecked(option)"
                                            (change)="onSingleSelectSpecial(option)">
                                            <span style="white-space: normal;">{{option.text}}</span>
                                        </mat-radio-button>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                    <!--REASONING-->
                    <div class="question" *ngIf="displayedQuestion.type == 'reasoning'">
                        <h2>{{index}}. <span [innerHTML]="displayedQuestion.text"></span></h2>
                        <div class="row text-left options">
                            <div class="option">
                                <div>{{ 'REMAINING_CHAR' | translate }} {{remainingChars}}</div>
                                <mat-form-field appearance="outline">
                                    <mat-label>{{displayedQuestion.freeFormAnswer.label}} </mat-label>
                                    <textarea
                                        [value]="displayedQuestion.freeFormAnswer.text ? displayedQuestion.freeFormAnswer.text: '' "
                                        matInput style="display: inline-block; font-size: 15.9px;" cdkTextareaAutosize
                                        cdkAutosizeMinRows="1" id="{{displayedQuestion.num}}"
                                        (input)="onType($event)" maxlength="510"></textarea>
                                </mat-form-field>
                            </div>
                            <div class="option">
                                <mat-radio-button value="{{displayedQuestion.availableOptions[0].text}}"
                                    [checked]="isChecked(displayedQuestion.availableOptions[0])"
                                    (change)="onSingleSelect(displayedQuestion.availableOptions[0])">
                                    <span
                                        style="white-space: normal;">{{displayedQuestion.availableOptions[0].text}}</span>
                                </mat-radio-button>

                            </div>
                        </div>
                    </div>
                    <!--INPUT-->
                    <div class="question" *ngIf="displayedQuestion.type == 'input'">
                        <h2>{{index}}. <span [innerHTML]="displayedQuestion.text"></span></h2>
                        <div class="row text-left options">
                            <div>{{ 'REMAINING_CHAR' | translate }}  {{remainingChars}}</div>
                            <div class="option">
                                <mat-form-field appearance="outline">
                                    <mat-label>{{displayedQuestion.freeFormAnswer.label}} </mat-label>
                                    <textarea
                                        [value]="displayedQuestion.freeFormAnswer.text ? displayedQuestion.freeFormAnswer.text: '' "
                                        matInput style="display: inline-block; font-size: 15.9px;" cdkTextareaAutosize
                                        cdkAutosizeMinRows="1" id="{{displayedQuestion.num}}"
                                        (input)="onType($event)" maxlength="510"></textarea>
                                </mat-form-field>
                            </div>

                        </div>
                    </div>
                    <!--MULTI SELECT -->
                    <div class="question" *ngIf="displayedQuestion.type == 'multi-select'">
                        <h2>{{index}}. <span [innerHTML]="displayedQuestion.text"></span></h2>
                        <div class="row text-left options">
                            <div class="" *ngFor="let option of displayedQuestion.availableOptions">
                                <div class="option">
                                    <mat-checkbox *ngIf="displayedQuestion.type == 'multi-select'"
                                        value="{{option.text}}" [checked]="isChecked(option)"
                                        (change)="onMultiSelect(option)">
                                        <span style="white-space: normal;">{{option.text}}</span>
                                    </mat-checkbox>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!--DRAG AND DROP-->
                    <div class="question" *ngIf="displayedQuestion.type === 'drag-and-drop'">
                        <h2>{{index}}. <span [innerHTML]="displayedQuestion.text"></span></h2>
                        <div class="col" cdkDropListGroup>
                            <div class="example-container col2">
                                <h2>{{'QUEST_T1' | translate}}</h2>
                                <div cdkDropList [cdkDropListData]="displayedQuestion.selectedOptions"
                                    class="example-list" (cdkDropListDropped)="onDrop($event)">
                                    <div class="example-box" *ngFor="let option of displayedQuestion.selectedOptions"
                                        cdkDrag>
                                        {{option.text}}</div>
                                </div>
                            </div>
                            <div class="example-container col1">
                                <h2>{{'QUEST_T2' | translate}}</h2>
                                <div cdkDropList [cdkDropListData]="displayedQuestion.availableOptions"
                                    class="example-list" (cdkDropListDropped)="onDrop($event)">
                                    <div class="example-box" *ngFor="let option of  displayedQuestion.availableOptions"
                                        cdkDrag>
                                        {{option.text}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="isDisplayed" class="buttons">
                        <!--PREVIOUS QUESTION BUTTON-->
                        <button [disabled]="disablePrev" id="prevId" class="button prev" mat-raised-button
                            (click)="showPrevQuestion()">{{'QUEST_B1' | translate}}
                        </button>
                        <!--SUBMIT BUTTON-->
                        <button (click)="onSubmit()" mat-raised-button="" class="button"
                            [disabled]="isDisabled && !testCompleted">
                            {{'SUBMIT' | translate}}
                        </button>
                        <!--NEXT QUESTION BUTTON-->
                        <button [disabled]="disableNext" id="nextId" class="button next" mat-raised-button
                            (click)="showNextQuestion()">{{'QUEST_B2' | translate}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>